var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"flex-column caption",attrs:{"app":"","absolute":""}},[_c('p',{staticClass:"ma-0"},[_vm._v("histify AG")]),_c('p',{staticClass:"ma-0"},[_c('a',{attrs:{"href":"https://www.histify.com","target":"_blank"}},[_vm._v("www.histify.com")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }